import { Box, Paper, Stack, Typography, Chip, Button, CircularProgress } from '@mui/material';
import { formatPrice, formatUnitPrice, formatNumber } from '../../utils/format';
import { pieceUnitPrice, lineTotal } from '../../utils/pricing';
import { b2bColors } from '../../styles/b2bTheme';
import QuantityStepper from '../../components/QuantityStepper';
import ProductThumb from '../../components/ProductThumb';
import FavoriteButton from '../../components/FavoriteButton';

export default function CatalogueMobileList({
    products, loading, quantityFor, onQuantityChange, onAdd,
}) {
    const showStaleOverlay = loading && products && products.length > 0;

    return (
        <Box sx={{ position: 'relative' }}>
            <Stack spacing={1.5} sx={{ opacity: showStaleOverlay ? 0.55 : 1, transition: 'opacity 120ms' }}>
                {products.map((p) => (
                    <Paper key={p.id} sx={{ p: 2 }}>
                        <Stack direction="row" spacing={1.5} alignItems="flex-start">
                            <ProductThumb src={p.image_url} alt={p.name} size={56} />
                            <Box sx={{ minWidth: 0, flex: 1 }}>
                                <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between">
                                    <Typography variant="body2" sx={{ fontSize: 11, color: b2bColors.textMuted, letterSpacing: '0.04em' }}>
                                        {p.sku}
                                    </Typography>
                                    {p.category?.name && (
                                        <Chip size="small" variant="outlined" label={p.category.name} sx={{ fontSize: 10, height: 20 }} />
                                    )}
                                </Stack>
                                <Typography sx={{ fontWeight: 600 }}>{p.name}</Typography>
                            </Box>
                            <FavoriteButton product={p} />
                        </Stack>
                        <Stack direction="row" spacing={1.5} alignItems="baseline" sx={{ mt: 1 }}>
                            <Typography className="b2b-num" sx={{ fontWeight: 700, fontSize: 18 }}>
                                {formatPrice(p.unit_price)}
                            </Typography>
                            <Typography variant="body2" sx={{ fontSize: 12, color: b2bColors.textMuted }}>
                                la caisse
                            </Typography>
                            {p.case_pack > 1 && (
                                <Typography className="b2b-num" variant="body2" sx={{ fontSize: 13, color: b2bColors.textMuted }}>
                                    · {formatUnitPrice(pieceUnitPrice(p))} la pièce
                                </Typography>
                            )}
                        </Stack>
                        <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 1 }} flexWrap="wrap" useFlexGap>
                            {p.total_on_hand > 0 ? (
                                <Chip size="small" color="success" variant="outlined" label={`${formatNumber(p.total_on_hand)} en stock`} />
                            ) : (
                                <Chip size="small" color="warning" variant="outlined" label="Rupture — ETA sur demande" />
                            )}
                            {p.case_pack > 1 && <Chip size="small" variant="outlined" label={`${p.case_pack} / caisse`} />}
                        </Stack>
                        <Stack direction="row" spacing={1} sx={{ mt: 1.5, alignItems: 'center' }}>
                            <QuantityStepper
                                value={quantityFor(p)}
                                onChange={(v) => onQuantityChange(p.id, v)}
                                casePack={p.case_pack}
                                ariaLabel={`Quantité pour ${p.name}`}
                            />
                            <Box sx={{ minWidth: 76 }}>
                                <Typography className="b2b-num" sx={{ fontWeight: 700, fontSize: 14, lineHeight: 1.2 }}>
                                    {formatPrice(lineTotal(p, quantityFor(p)))}
                                </Typography>
                                <Typography sx={{ fontSize: 10, color: b2bColors.textDisabled, lineHeight: 1.2 }}>
                                    total
                                </Typography>
                            </Box>
                            <Button
                                variant="contained"
                                onClick={() => onAdd(p)}
                                disabled={quantityFor(p) <= 0 || p.total_on_hand <= 0}
                                fullWidth
                            >
                                Ajouter
                            </Button>
                        </Stack>
                    </Paper>
                ))}
            </Stack>

            {showStaleOverlay && (
                <Box sx={{
                    position: 'absolute', top: 4, right: 8,
                    display: 'flex', alignItems: 'center', gap: 1,
                    color: b2bColors.textMuted, fontSize: 12,
                }}>
                    <CircularProgress size={14} thickness={5} />
                    Mise à jour…
                </Box>
            )}
        </Box>
    );
}
